import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

// Create the context
const UserContext = createContext();

// Provide the context
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);

  // Example: Check localStorage for user token and type on mount
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
        setUserRole(decoded.userRole || 'user'); // Set default role to 'user'
      } catch (error) {
        console.error('Error decoding token:', error);
        localStorage.removeItem('token');
      }
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    setUser(userData);
    setUserRole(userData.userRole || 'user');
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setUserRole(null);
  };

  return (
    <UserContext.Provider value={{ user, userRole, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};

// Hook to use the UserContext
export const useUser = () => useContext(UserContext);
